import { Box, HStack, Heading, useColorModeValue } from "@chakra-ui/react";
import { CellClickedEvent, ColDef } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { useRef } from "react";
import { NoPatientData } from "../../no-data";
import { TableGrid } from "../../table-grid";
import type { FhirSectionProps } from "../fhir-section";

type RawDocumentsSectionProps = Omit<FhirSectionProps, "handleCellClick"> & {
  handleCellClick: (sectionId: string, event: { data: object; event?: unknown }) => void;
};

function RawDocumentsSection(props: RawDocumentsSectionProps) {
  const defaultColDef: ColDef = {
    flex: 1,
    onCellClicked: (event: CellClickedEvent) =>
      props.handleCellClick(props.sectionId, event as unknown as { data: object; event?: unknown }),
    cellStyle: props.handleCellStyle,
  };

  const gridRef = useRef<AgGridReact>(null);

  const {
    sectionId,
    sectionName,
    rowData,
    columnDefs,
    denseDisplay,
    usingSectionSearch,
    usingMetriportOnlyBundleFromConsolidated,
  } = props;

  return (
    <Box
      id={sectionId}
      w={"100%"}
      mb={5}
      borderRadius={10}
      bg={useColorModeValue("white", "gray.800")}
      px={7}
      py={5}
      border="solid"
      borderColor={useColorModeValue("gray.200", "gray.700")}
    >
      <HStack mb={5} w={"100%"} justifyContent={"space-between"}>
        <Heading size={denseDisplay ? "xs" : "md"}>{sectionName}</Heading>
      </HStack>
      {rowData.length > 0 ? (
        <TableGrid
          ref={gridRef}
          defaultColDef={defaultColDef}
          columnDefs={columnDefs}
          rowData={rowData}
          usingSectionSearch={usingSectionSearch}
        />
      ) : (
        <NoPatientData
          message={
            usingMetriportOnlyBundleFromConsolidated ? "EHR is in sync" : "No Data Available"
          }
        />
      )}
    </Box>
  );
}

export default RawDocumentsSection;
